import { types } from "../action-types";

const initialState = {
  loading: false,
  absList: [],
  error: false,
};

const absReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ABS_DETAILS_INIT:
      return {
        ...state,
        loading: true,
      };

    case types.ABS_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        absList: action.payload?.data,
        error: false,
      };
    case types.ABS_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        absList: [],
        error: true,
      };
    default:
      return state;
  }
};

export default absReducer;
